export default "__VITE_ASSET__ea42ca5c__"